import RequiredValidator from "@/validators/RequiredValidator";

export default class BrandRules {

	public static readonly nameRules = [
		(new RequiredValidator('brand.name')).validationRule(),
	];

	public static readonly imageRules = [
		(new RequiredValidator('ui.terms.selectImageFile')).validationRule(),
	];
}
